import React from "react";
import { Link } from "react-router-dom";
import { FaPhone, FaEnvelope, FaHome } from "react-icons/fa";

function Footer() {
  return (
    <footer>
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-section">
            <h3>About Tanarela</h3>
            <p>
              Premium landscape design materials and natural stone products for
              creating stunning outdoor spaces across Australia. We are
              committed to quality and sustainability.
            </p>
            <p style={{ marginTop: "1rem", fontSize: "0.95rem" }}>
              <strong>ABN:</strong> 01456649
            </p>
          </div>

          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul className="footer-links">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
              <li>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms-conditions">Terms and Conditions</Link>
              </li>
              <li>
                <Link to="/refund-policy">Refund Policy</Link>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Contact Information</h3>
            <div className="footer-contact-item">
              <FaHome className="footer-icon" />
              <span>157 Ann St, Brisbane City QLD 4000, Australia</span>
            </div>
            <div className="footer-contact-item">
              <FaPhone className="footer-icon" />
              <span>+61485588246</span>
            </div>
            <div className="footer-contact-item">
              <FaPhone className="footer-icon" />
              <a href="https://wa.me/61485588246">WhatsApp</a>
            </div>
            <div className="footer-contact-item">
              <FaPhone className="footer-icon" />
              <a href="https://viber.me/61485588246">Viber</a>
            </div>
            <div className="footer-contact-item">
              <FaEnvelope className="footer-icon" />
              <span>
                <a href="mailto:tanarela@hotmail.com">tanarela@hotmail.com</a>
              </span>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            &copy; 2026 Tanarela. All rights reserved. Premium landscape design
            materials in Australia.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
